// Dépendances Angular
import { inject, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';

// Dépendances Externes
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';

// Fichiers du projet
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { configSSO } from '@environments/sso/auth-sso';
import { SharedModule } from '@shared/shared.module';
import {
  AuthenticationComponent,
  AssistanceComponent,
  CallbackComponent,
  ConstatationListComponent,
  ConstatationDetailsComponent,
} from '@features/index';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpTokenInterceptor } from '@core/interceptor/http.interceptor';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';

@NgModule({
  declarations: [
    AppComponent,
    AuthenticationComponent,
    AssistanceComponent,
    CallbackComponent,
    ConstatationListComponent,
    ConstatationDetailsComponent,
  ],
  imports: [
    // Dépendances Angular
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,

    // Dépendances externes
    SharedModule,
    OAuthModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    provideHttpClient(withInterceptors([HttpTokenInterceptor])),
    // PrimeNG MessageService backs <p-toast> + ToasterService (i-essentials).
    // i-essentials ne le fournit pas (contrairement au ConfirmationService) → on le fournit ici.
    // NB : le theming PrimeNG est déjà configuré par IEssentialsModule (preset Inforius),
    // inutile d'appeler providePrimeNG ici.
    MessageService,
    DynamicDialogRef,
  ],
})
export class AppModule {
  private oAuthService: OAuthService = inject(OAuthService);

  constructor() {
    this.oAuthService.configure(configSSO);
    this.oAuthService.setupAutomaticSilentRefresh({}, 'access_token');
    this.oAuthService.loadDiscoveryDocumentAndTryLogin();
  }
}
